import React, { Component } from "react";
import { Button } from "@material-ui/core";
import Moment from "react-moment";
import { GetOrderDetails } from "../../../../services";

export default class View extends Component {
  constructor(props) {
    super(props);
    this.state = {
      getList: [],
      isloaded: false,
      batch: 1,
      perPage: 10,
      orgtableData: [],
      search: "",
      message: "",
    };
  }

  handleBack = () => {
    this.props.history.goBack();
  };

  async getOrderList() {
    this.setState({ isloaded: true, message: "" });

    const list = await GetOrderDetails.getAllOrderList(
      this.state.batch,
      this.state.search
    );

    if (!list || list.success === false) {
      this.setState({
        getList: [],
        message: list && list.message ? list.message : "No records found",
        isloaded: false,
      });
      return;
    }

    const data = list.order || [];
    this.setState({
      orgtableData: data,
      getList: data.slice(0, this.state.perPage),
      isloaded: false,
    });
  }

  handleChangeBatch = (direction) => {
    let newBatch = this.state.batch + direction;
    if (newBatch < 1) newBatch = 1;

    this.setState({ batch: newBatch }, () => {
      this.getOrderList();
      window.scrollTo(0, 0);
    });
  };

  componentDidMount() {
    this.getOrderList();
  }

  render() {
    const { getList, batch, search, message } = this.state;

    return (
      <div>
        <main>
          <div className="container-fluid">
            <div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 30,
    marginBottom: 20,
  }}
>
  <h2 className="page-title" style={{ margin: 0 }}>
    Orders
  </h2>

  <Button
    variant="contained"
    color="secondary"
    onClick={() => this.props.history.push("/admin/order/add-order")}
  >
    Add Order
  </Button>
</div>


            {/* 🔍 SEARCH */}
            <div style={{ marginBottom: 15 }}>
              <input
                type="text"
                placeholder="Search by Email or Phone"
                value={search}
                onChange={(e) => this.setState({ search: e.target.value })}
                style={{ marginRight: 10 }}
              />
              <Button
                variant="contained"
                color="primary"
                onClick={() => this.getOrderList()}
              >
                Search
              </Button>
            </div>

            <div className="card card-static-2 mb-30">
              <div className="card-body-table">
                <div className="table-responsive">
                  <table className="table ucp-table table-hover">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Order ID</th>
                        <th>Order Date</th>
                        <th>Customer</th>
                        <th>Total</th>
                        <th>Order Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      {message ? (
                        <tr>
                          <td
                            colSpan="6"
                            style={{ textAlign: "center", color: "red" }}
                          >
                            {message}
                          </td>
                        </tr>
                      ) : getList.length === 0 ? (
                        <tr>
                          <td colSpan="6">Loading...</td>
                        </tr>
                      ) : (
                        getList.map((row, index) => (
                          <tr key={index}>
                            <td>{row.id}</td>
                            <td>{row.number}</td>
                            <td>
                              <Moment format="MMMM Do YYYY">
                                {row.createdAt}
                              </Moment>
                              <br />
                              <Moment format="h:mm:ss a">
                                {row.createdAt}
                              </Moment>
                            </td>
                            <td>
                              <div>
                                <strong>
                                  {row.customer && row.customer.fullName
                                    ? row.customer.fullName
                                    : "N/A"}
                                </strong>
                              </div>
                              <div>
                                {row.customer && row.customer.email
                                  ? row.customer.email
                                  : "N/A"}
                              </div>
                              <div>
                                {row.customer && row.customer.phone
                                  ? row.customer.phone
                                  : "N/A"}
                              </div>
                            </td>
                            <td>₹{row.grandtotal}</td>
                            <td>
                              {row.orderPaths.map((p, i) => (
                                <div key={i}>
                                  <strong>{p.productName}</strong>
                                  {p.variants.map((v, j) => (
                                    <div key={j}>Variant: {v.variantName}</div>
                                  ))}
                                </div>
                              ))}
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>

                {/* PAGINATION */}
                <div className="pagination-buttons">
                  <Button
                    variant="contained"
                    onClick={() => this.handleChangeBatch(-1)}
                    disabled={batch <= 1}
                  >
                    Previous Batch
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => this.handleChangeBatch(1)}
                    style={{ marginLeft: 10 }}
                  >
                    Next Batch
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/view/order/view/index.js